import { type ColumnDef } from '@tanstack/react-table';

import { DateCell } from '@/components/composed/DateCell';
import {
  StatusBadge,
  type StatusTone,
} from '@/components/composed/StatusBadge';
import type { TableFeatures } from '@/components/composed/DataTable/table-features';
import type { EntityContract } from '@/lib/api/domains/entity-contracts';

const STATUS_TONE: Record<EntityContract['status'], StatusTone> = {
  draft: 'neutral',
  sent: 'info',
  signed: 'success',
  expired: 'danger',
};

const STATUS_LABEL: Record<EntityContract['status'], string> = {
  draft: 'Draft',
  sent: 'Sent',
  signed: 'Signed',
  expired: 'Expired',
};

/*
 * Columns mirror the prototype entity-contracts list (Partner Name ·
 * Relationship Type · Effective Date · Contract Status). This is a flat
 * contracts-management list, not an entity list — no publicId/TIN column.
 */
export const entityContractColumns: Array<
  ColumnDef<TableFeatures, EntityContract>
> = [
  {
    accessorKey: 'partnerName',
    header: 'Partner Name',
    cell: (info) => (
      <span className="font-medium">{info.getValue<string>()}</span>
    ),
  },
  {
    accessorKey: 'relationshipType',
    header: 'Relationship Type',
    cell: (info) => info.getValue<string>(),
  },
  {
    accessorKey: 'effectiveDate',
    header: 'Effective Date',
    cell: (info) => {
      const value = info.getValue<string | undefined>();
      return value ? <DateCell value={value} /> : null;
    },
  },
  {
    accessorKey: 'status',
    header: 'Contract Status',
    cell: (info) => {
      const status = info.getValue<EntityContract['status']>();
      return (
        <StatusBadge label={STATUS_LABEL[status]} tone={STATUS_TONE[status]} />
      );
    },
  },
];
